var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOs2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_429_3127)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.75 1.46484H16.0977",
    stroke: "#012060",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.25977 1.46484H1.46484V98.5352H51.748",
    stroke: "#012060",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8438 97.8128V2.18701",
    stroke: "#012060",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 76.7461V96.7871C50 97.752 50.7832 98.5352 51.748 98.5352H96.7871C97.752 98.5352 98.5352 97.752 98.5352 96.7871V51.748C98.5352 50.7832 97.752 50 96.7871 50H80.0352",
    stroke: "#012060",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1992 50H52.7559C51.2344 50 50 51.2344 50 52.7559V69.9102",
    stroke: "#012060",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.0742,
    cy: 57.1826,
    r: 1.46484,
    fill: "#012060"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.0742,
    cy: 91.5723,
    r: 1.46484,
    fill: "#012060"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91.4609,
    cy: 91.5723,
    r: 1.46484,
    fill: "#012060"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91.4609,
    cy: 57.1826,
    r: 1.46484,
    fill: "#012060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7559 50C51.2338 50 50 48.7662 50 47.2441V3.21328C50 2.24766 50.7828 1.46484 51.7484 1.46484H96.7867C97.7523 1.46484 98.5352 2.24766 98.5352 3.21328V48.2516C98.5352 49.2172 97.7523 50 96.7867 50",
    stroke: "#012060",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.0742,
    cy: 8.86768,
    r: 1.46484,
    fill: "#012060"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.0742,
    cy: 43.2573,
    r: 1.46484,
    fill: "#012060"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91.4609,
    cy: 43.2573,
    r: 1.46484,
    fill: "#012060"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91.4609,
    cy: 8.86768,
    r: 1.46484,
    fill: "#012060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.26172 50H2.05859",
    stroke: "#012060",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2109 50H16.0977",
    stroke: "#012060",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.457 14.5872H50.0002",
    stroke: "#012060",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1641 85.4131H49.4189",
    stroke: "#012060",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_429_3127"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOs2);
export default __webpack_public_path__ + "static/media/os2.df2e66975c48f4d4ed453a8ecdc22d6c.svg";
export { ForwardRef as ReactComponent };